export * from './lib/shared-legal-documents.module';
export * from './lib/required-legal-documents/required-legal-documents.component';
export * from './lib/legal-documents.service';
export * from './lib/has-legal-docs.guard';
export * from './lib/interceptors/mock-legal-docs.interceptor';
